import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { SummaryList, MobileStrip } from 'Components';
import './OverviewMobile.css';

const OverviewMobile = (props) => {
  const templatesMobileKeys = {
    fixedkeys: (props.templatesData.keys || []).slice(0, 4),
    bodyKeys: ['ProjectNumber', 'SiteLocation', 'POAFENumber', 'SiteNumber', 'CreatedByName', 'CreatedDate'],
    uniqueKey: 'Id',
    code: 'template',
  };

  const jobsMobileKeys = {
    fixedkeys: [...(props.jobsData.keys || []).slice(0, 2), 'ReceivedDate', 'Submitted'],
    bodyKeys: (props.jobsData.keys || []).slice(2, 8),
    uniqueKey: 'SubmissionId',
    code: 'job',
  };

  const suppliesMobileKeys = {
    fixedkeys: [...(props.ordersData.keys || []).slice(0, 2), 'Shipped', 'StatusName'],
    bodyKeys: ['OrderNumber', 'Placed', 'Shipped', 'ProjectNumber', 'CreatedBy', 'Waybill'],
    uniqueKey: 'OrderNumber',
    code: 'order',
  };

  const invoicesMobileKeys = {
    fixedkeys: ['AmountRemaining', ...(props.invoicesData.keys || []).slice(0, 1), 'InvoiceNumber', 'InvoiceDate'],
    uniqueKey: 'InvoiceNumber',
    code: 'invoice',
  };

  return (
    <div className="overview__mobile">
      <MobileStrip
        title="Overview"
        right="/templates"
      />
      <h4 className="overview__mobile__header">{i18n.t('overview:Recent Activity')}</h4>
      <SummaryList
        mobileKeys={templatesMobileKeys}
        hasPinned
        setPageState={props.setPageState}
        viewCode={props.templatesData.viewCode}
        data={{ ...props.templatesData }}
        powerTableIndex={props.powerTableViewCode === 'overviewTemplates' ? props.powerTableIndex : null}
        onOptionClick={props.onOptionClick}
        onPinClick={index => props.onPinClick(index, 'overviewTemplates')}
        keyPairs={props.templatesData.keyPairs}
        title={i18n.t('head:eCOC Templates')}
        description={props.placeholderDescription('template', '/templates/new')}
        isSupplyWarningON={props.isSupplyWarningON}
        isTemplateWarningON={props.isTemplateWarningON}
        isSubmissionWarningON={props.isSubmissionWarningON}
        isPrepaid={props.isPrepaid}
      />
      <SummaryList
        mobileKeys={jobsMobileKeys}
        setPageState={props.setPageState}
        powerTableIndex={props.powerTableViewCode === 'overviewJobs' ? props.powerTableIndex : null}
        viewCode={props.jobsData.viewCode}
        data={{ ...props.jobsData }}
        onOptionClick={props.onOptionClick}
        keyPairs={props.jobsData.keyPairs}
        title={i18n.t('head:Jobs')}
        description={props.placeholderDescription('job', '/jobs/new')}
        isSupplyWarningON={props.isSupplyWarningON}
        isTemplateWarningON={props.isTemplateWarningON}
        isSubmissionWarningON={props.isSubmissionWarningON}
        isPrepaid={props.isPrepaid}
      />
      <SummaryList
        hasPinned
        mobileKeys={suppliesMobileKeys}
        setPageState={props.setPageState}
        viewCode={props.ordersData.viewCode}
        data={{ ...props.ordersData }}
        powerTableIndex={props.powerTableViewCode === 'overviewOrders' ? props.powerTableIndex : null}
        onOptionClick={props.onOptionClick}
        onPinClick={index => props.onPinClick(index, 'overviewOrders')}
        keyPairs={props.ordersData.keyPairs}
        title={i18n.t('head:Supplies')}
        description={props.placeholderDescription('order', '/supplies/new')}
        isSupplyWarningON={props.isSupplyWarningON}
        isTemplateWarningON={props.isTemplateWarningON}
        isSubmissionWarningON={props.isSubmissionWarningON}
        isPrepaid={props.isPrepaid}
      />
      <SummaryList
        mobileKeys={invoicesMobileKeys}
        setPageState={props.setPageState}
        powerTableIndex={props.powerTableViewCode === 'overviewInvoices' ? props.powerTableIndex : null}
        viewCode={props.invoicesData.viewCode}
        data={{ ...props.invoicesData }}
        onOptionClick={props.onOptionClick}
        keyPairs={props.invoicesData.keyPairs}
        title={i18n.t('head:Invoices')}
        description={props.InvoiceDescription}
      />
    </div>
  );
};

OverviewMobile.propTypes = {
  onOptionClick: PropTypes.func,
  setPageState: PropTypes.func,
  powerTableViewCode: PropTypes.string,
  powerTableIndex: PropTypes.number,
  onPinClick: PropTypes.func,
  templatesData: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.shape([]),
    keys: PropTypes.shape([]),
    keyPairs: PropTypes.shape({}),
    viewCode: PropTypes.string,
  }),
  jobsData: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.shape([]),
    viewCode: PropTypes.string,
    keys: PropTypes.shape([]),
    keyPairs: PropTypes.shape({}),
  }),
  invoicesData: PropTypes.shape({
    isLoading: PropTypes.bool,
    viewCode: PropTypes.string,
    data: PropTypes.shape([]),
    keys: PropTypes.shape([]),
    keyPairs: PropTypes.shape({}),
  }),
  ordersData: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.shape([]),
    keys: PropTypes.shape([]),
    keyPairs: PropTypes.shape({}),
    viewCode: PropTypes.string,
  }),
  placeholderDescription: PropTypes.func,
  InvoiceDescription: PropTypes.shape({}),
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  isPrepaid: PropTypes.bool,
};

export default OverviewMobile;



// WEBPACK FOOTER //
// ./src/containers/Overview/OverviewMobile/OverviewMobile.jsx